// extracted by mini-css-extract-plugin
export default {"dimmed-value":"_1UlWX","dimmedValue":"_1UlWX","gems-cell":"_2yLl5","gemsCell":"_2yLl5","gems":"_1SqLQ"};